import Handlers from '../dispatcher/Handlers';
import { ActionTypes } from '../constants/CentricConstants';
import VendorApi from '../server/VendorApi';


export default {

    getAll: function(params) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.VENDOR_LIST);
        const handleError = Handlers.createErrorHandler(ActionTypes.VENDOR_LIST_ERROR);

        return VendorApi.getAll(params)
            .then(handleSuccess, handleError)
            .catch(Handlers._handleException);
    },
    
    save: function(entity) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.VENDOR_SAVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = Handlers.createErrorHandler(ActionTypes.VENDOR_SAVE_ERROR, ActionTypes.FORM_SUBMIT_ERROR);

        return VendorApi.save(entity)
            .then(handleSuccess, handleError)
            .catch(Handlers._handleException);
    },

    getById: function(id) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.VENDOR_INFO);
        const handleError = Handlers.createErrorHandler(ActionTypes.VENDOR_INFO_ERROR);

        return VendorApi.getById(id)
            .then(handleSuccess, handleError)
            .catch(Handlers._handleException);
    },
    
    update: function(id, entity) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.VENDOR_UPDATE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = Handlers.createErrorHandler(ActionTypes.VENDOR_UPDATE_ERROR, ActionTypes.FORM_SUBMIT_ERROR);

        return VendorApi.update(id, entity)
            .then(handleSuccess, handleError)
            .catch(Handlers._handleException);
    },

    delete: function(id) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.VENDOR_DELETE);
        const handleError = Handlers.createErrorHandler(ActionTypes.VENDOR_DELETE_ERROR, ActionTypes.FORM_SUBMIT_ERROR);

        return VendorApi.delete(id)
            .then(handleSuccess, handleError)
            .catch(Handlers._handleException);
    },

};
